import { Banner } from "@/enums/Banner";
import { IBanner } from "@/models/Banner";

export const BANNER_VALUATION: IBanner = {
  id: Banner.VALUATION,
  icon: "illustrations/calculator",
  title: "common.howMuchIsYourFlatWorth",
  description: "common.discoverTheMarketValueOfYourFlat",
  ctaText: "common.appraiseMyProperty",
  tracking: "button_services-banner_valuation",
};

export const BANNER_MORTGAGE: IBanner = {
  id: Banner.MORTGAGE,
  icon: "illustrations/mortgage",
  title: "common.getYourMortgage",
  description: "common.weNegotiateWithBanks",
  ctaText: "common.getFreeInformation",
  tracking: "button_services-banner_mortgage",
};

export const BANNER_SELLER: IBanner = {
  id: Banner.SELLER,
  icon: "illustrations/sell-home-white",
  title: "common.sellYourProperty",
  description: "common.in60DaysAndWithoutCommissions",
  ctaText: "common.getFreeInformation",
  tracking: "button_tools-banner_get-free-information",
};
